$(document).on("click", ".tabs_main_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tabs_main_item').removeClass('active');
$(this).addClass('active');
$('.columns_center_slider_tab').hide();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"]').show();
$('.columns_center_slider_tab[data_tab="'+data_tab+'"] .slick-slider').slick('refresh');
});
$(document).on("click", ".custom_button", function (e) {
    var currentWrapper = jQuery(this).parents('.video_wrapper_custom');
    var currentVideo = currentWrapper.find('video');

    if (jQuery(this).hasClass("active")) {
        currentWrapper.removeClass('video-active');
        jQuery(this).removeClass('active');
        currentVideo.trigger('pause');
    } else {
        // Pause all other videos and reset buttons
        jQuery('.video_wrapper_custom').each(function () {
            var wrapper = jQuery(this);
            var video = wrapper.find('video');
            var button = wrapper.find('.custom_button');

            video.trigger('pause');
            wrapper.removeClass('video-active');
            button.removeClass('active');
        });

        // Play current video
        currentVideo.trigger('play');
        currentWrapper.addClass('video-active');
        jQuery(this).addClass('active');
    }
});


$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".trigger_js_show_more", function (e) {
$(this).hide();
$(this).next().show();
$('.custom_mobile_non_slider_reviews>div:first-child~*').show();
});
$(document).on("click", ".trigger_js_show_less", function (e) {
$(this).hide();
$(this).prev().show();
$('.custom_mobile_non_slider_reviews>div:first-child~*').hide();
});


$(document).on("click", '.search_trigger_button', function (e) {
var text = $(this).prev().val();
text = text.trim();
text = text.replace(" ", "+");
var link = '/search';
var new_link = link+'?q='+text;
  location.href=new_link;
});


$('.header_custom_search input').keypress(function (e) {
if (e.which == '13') {
 $(this).next().trigger('click');
}});


$(document).on("click", "a[href='#benifits']", function (e) {
  e.preventDefault();
  document.querySelector('#benifits').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
 jQuery('body').addClass('window-os'); 
}
});



$(document).on("click", '.ajax_add_cart', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");
this_element.removeClass('loading_hk'); 
}, 500);
 } 
 });
  });





$(document).on("click", "summary#HeaderMenu-all-products", function (e) {
var url = $(this).attr('href');
location.href=url;
});
$(document).on("click", "summary#HeaderMenu-more", function (e) {
e.preventDefault();
});


$(document).ready(function () {
  $(".mega-menu").hover(function(){
$('body').addClass('mega_menu_open');
$(this).attr('open','open');
$('ul.mega-menu__list.page-width.mega-menu__list--condensed.new_all_products_ul').slick({
  dots: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  infinite: true,
    prevArrow: '<div class="slider_button_custom custom_prev prev_mega_menu"><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none"><path d="M19.2551 37.7406C29.4633 37.7406 37.7387 29.4652 37.7387 19.257C37.7387 9.04883 29.4633 0.773438 19.2551 0.773438C9.04687 0.773438 0.771484 9.04883 0.771484 19.257C0.771484 29.4652 9.04687 37.7406 19.2551 37.7406Z" fill="#FBF9F7" stroke="#3C3224" stroke-width="1.54427"/><path d="M14.3425 19.9368C13.9666 19.5608 13.9666 18.9512 14.3425 18.5752L20.4697 12.448C20.8457 12.072 21.4553 12.072 21.8313 12.448C22.2073 12.824 22.2073 13.4336 21.8313 13.8096L16.3849 19.256L21.8313 24.7023C22.2073 25.0783 22.2073 25.6879 21.8313 26.0639C21.4553 26.4399 20.8457 26.4399 20.4697 26.0639L14.3425 19.9368Z" fill="#3C3224"/></svg></div>',
    nextArrow: '<div class="slider_button_custom custom_next next_mega_menu"><svg xmlns="http://www.w3.org/2000/svg" width="39" height="39" viewBox="0 0 39 39" fill="none"><path d="M19.2547 37.7406C9.04647 37.7406 0.77108 29.4652 0.77108 19.257C0.77108 9.04883 9.04647 0.773438 19.2547 0.773438C29.4629 0.773438 37.7383 9.04883 37.7383 19.257C37.7383 29.4652 29.4629 37.7406 19.2547 37.7406Z" fill="#FBF9F7" stroke="#3C3224" stroke-width="1.54427"/><path d="M24.1691 19.9368C24.5451 19.5608 24.5451 18.9512 24.1691 18.5752L18.042 12.448C17.666 12.072 17.0564 12.072 16.6804 12.448C16.3044 12.824 16.3044 13.4336 16.6804 13.8096L22.1267 19.256L16.6804 24.7023C16.3044 25.0783 16.3044 25.6879 16.6804 26.0639C17.0564 26.4399 17.666 26.4399 18.042 26.0639L24.1691 19.9368Z" fill="#3C3224"/></svg></div>',
  cssEase:'linear',
  responsive: [
    {
      breakpoint: 915,
      settings: {
        speed: 300,
        slidesToShow:1,
      }
    }
  ]
});
}, function(){
$(this).removeAttr('open');
$('body').removeClass('mega_menu_open');
});
});